<template>
  <div class="content">
    <div class="content_title">
      Список документов
    </div>
    <div class="content_row" v-for="(document, key) in documents" :key="key">
      <div>
        {{ document.NAME }}
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "GetDocuments",
  props: {
    updateList: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      url: config.backend_url,
      documents: []
    };
  },
  computed: {},
  watch: {
    updateList: function(state) {
      if (state) {
        this.getDocuments();
      }
    }
  },
  methods: {
    getDocuments: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "documents/get-user-documents/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.documents = data;
            if (self.updateLists) {
              self.$emit("document-list-update");
            }
          }
        });
    }
  },
  created() {
    this.getDocuments();
  }
};
</script>
